<template>
  <div class="accou_body">
    <div class="zhanghu">
      <div class="tupian"><img src="/lanse.jpg"></div>
      <div class="zichan">总资产(元)</div>
      <div class="yue">{{jine}}</div>
    </div>

    <div class="beij"></div>


    <div class="yubody">
      <div class="yuan">
        <div class="zhye">账户余额(元)</div>
        <div class="qian">{{jine}}</div>
      </div>
      <div class="ti">
        <van-button type="default" size="small" @click="chongzhi">提现</van-button>
        <van-button type="primary" size="small" @click="tixian">充值</van-button>
      </div>
    </div>

    <div class="beij"></div>

    <router-link :to="{path:'/detail'}" tag="div">
      <div class="itme">
        <img class="lefticon" src="/zhanghu.png">
        <span>账户明细</span>
        <img class="righticon" src="/rightjt.png" alt="">
      </div>
    </router-link>

<!--    <router-link :to="{path:'/certification'}" tag="div">-->
      <div class="itme" @click="shiming">
        <img class="lefticon" src="/shiming.png">
        <span>实名认证</span>
        <span style="border-radius: 4px;background: #07c160;padding: 0 3px;color: #ffffff">{{name!=null?'已认证':'暂未认证'}}</span>
        <img class="righticon" src="/rightjt.png" alt="">
      </div>
<!--    </router-link>-->

    <div class="itme" @click="shoujiren">
      <img class="lefticon" src="/bangdingmobile.png">
      <span>绑定手机</span>
      <span style="border-radius: 4px;background: #07c160;padding: 0 3px;color: #ffffff">{{shouji!=""?'已绑定':'暂未绑定'}}</span>
      <img class="righticon" src="/rightjt.png" alt="">
    </div>


  </div>
</template>

<script>
    export default {
        name: "account",
        data() {
            return {
                name:'',
                jine:'',
                shouji:'',
            }
        },
        created() {
            this.getdata()
        },
        methods: {
            chongzhi() {
                //提现跳转
                this.$router.push({path: '/topup'})
            },
            tixian() {
                //充值跳转
                this.$router.push({path: '/withdrawal'})
            },
            //实名认证跳转
            shiming(){
                if(this.name==null || this.name==''){
                    this.$router.push({path: '/shiming'})
                }

            },
            shoujiren(){
                if(this.shouji==null || this.shouji==''){
                    this.$router.push({path: '/Mobile'})
                }
            },
            getdata() {
                this.myrequest({
                    url:'/client/getmyinfo.action',
                    types:'get',
                    data:{
                        // token:this.$store.state.token
                    },
                    succ: (res) => {
                        this.jine=res.data.fee
                        this.shouji=res.data.mobile
                        this.name=res.data.sfz
                    },
                    errs: (msg) => {

                    }
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
  .beij {

    background-color #fafafa;
    width 100%;
    height 10px;
    margin-top 20px;
  }

  .accou_body {
    width 100%;

    .zhanghu {
      position relative;
      width 95%;
      margin 10px auto;

      .tupian {
        width 100%;

        img {
          width 100%;
          height 150px;
          border-radius 10px;
        }
      }

      .zichan {
        position absolute
        top 30%;
        left 40%;
        font-size 16px;
        color #ffffff;
        font-weight 500
      }

      .yue {
        position absolute
        top 45%;
        left 45%;
        font-size 14px;
        color #ffffff;
        font-weight 500
      }
    }

    .yubody {
      width 100%;
      display flex;
      flex-direction: row;
      align-items: center;
      /*justify-content: center;*/

      .yuan {
        text-align center;
        margin-left 10px;
        margin-top 10px;

        .zhye {
          font-size 16px;
          color #9e9e9e;
        }

        .qian {
          font-size 14px;
          color #333333;
          margin-top 10px;
        }
      }

      .ti {
        margin-left 38%;
      }
    }

    .itme {
      background #fff
      width 100%
      display flex
      position relative
      align-items center
      height 40px
      padding-left 10px
      border-bottom 1px solid #f5f5f5

      .lefticon {
        width 20px
        height 20px
      }

      span {
        margin-left 10px
        font-size 14px
      }

      .righticon {
        position absolute
        right 20px
        width 15px
        height 15px
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/wode/account.vue